import styled, { css } from 'styled-components';
import { mediaQuery, StyledH1 as _StyledH1, StyledH3 as _StyledH3 } from 'components';
import { StyledH1Props } from '../CategoryHeader';

const BANNER_CONTENT_SELECTOR = '.banner__content.banner__content--centered.banner__content--centered-small';

export const StyledBanner = styled.div`
  margin-bottom: 20px;

  .grid-row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
  }

  .-xsmall-12-12 {
    flex-basis: 100%;
    margin: 0 10px 20px;
  }

  .col-6-12 {
    ${mediaQuery.medium`
      flex-basis: calc(50% - 20px);
    `};
  }

  ${BANNER_CONTENT_SELECTOR} {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 20px;
    text-align: center;
    height: 100%;

    ${mediaQuery.medium`
      padding: 100px 50px;
    `};

    .txt-dsp-1 {
      margin-bottom: 50px;
      flex-grow: 1;

      ${mediaQuery.medium`
        margin-bottom: 100px;
      `};
    }
  }

  .banner__content-title {
    border-bottom: 1px solid;
    padding-bottom: 20px;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 1.5px;
  }

  .banner__content-title-contain {
    margin-bottom: 50px;

    ${mediaQuery.medium`
      margin-bottom: 100px;
    `};
  }

  .action-btn {
    padding: 15px 28px;
    border: 1px solid;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1.5px;
  }

  .bg-gray-blue {
    background-color: #38545c;
  }

  .bg-faded-pink {
    background-color: #c6baba;
  }

  .wedding-collections-banner-3 {
    display: none;

    ${mediaQuery.medium`
      display: block;
      padding-bottom: 50.63291139%;
    `};
  }
`;

export const HeroBanner = styled.div`
  .module.hero.hero-promo.holiday-cards-2018-hero {
    background-position: center right !important;

    ${mediaQuery.medium`
      background-position: center !important;
    `};
  }

  .txt-dsp-2 {
    margin-left: 18px;
    margin-top: 160px;
  }

  .hero {
    display: none;

    ${mediaQuery.medium`
      display: block;
      height: 360px;
      margin-left: -50vw;
      padding: 0;
      position: relative;
      left: 50%;
      width: 100vw;
    `};

    .hero-content {
      margin: auto;
      max-width: 1180px;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .page-title {
    font-family: 'Crimson Text', 'Georgia', serif;
    font-weight: normal;
    font-size: 24px;
    margin: 0;

    ${mediaQuery.medium`
      font-size: 2.8125rem;
    `};
  }

  .holiday-cards-2017-hero {
    display: block;
    height: 200px;
    padding: 0;

    ${mediaQuery.medium`
      height: 500px;
    `};

    .hero-content {
      margin: 0;
      padding: 0;
      height: 100%;

      ${mediaQuery.medium`
        margin: .5em 7em 0;
      `};
    }

    .cat-heading {
      margin: 0 !important;
    }

    #page-title-left {
      margin: 30px 0 0 !important;
    }

    label {
      margin: 0;
    }
  }

  .folded-photo-cards-hero {
    background-image: url(https://cdn.artifactuprising.com/assets/images/plp/folded-photo/banner-folded-photo-cards-tablet.jpg?auto=webp&width=1200);

    @media screen and (min-width: 1028px) {
      background-image: url(https://cdn.artifactuprising.com/assets/images/plp/folded-photo/banner-folded-photo-cards-desktop.jpg?auto=webp&width=1000);
    }

    @media only screen and (-webkit-min-device-pixel-ratio: 1.3) and (max-width: 1028px),
      only screen and (-o-min-device-pixel-ratio: 13/10) and (max-width: 1028px),
      only screen and (min-resolution: 120dpi) and (max-width: 1028px) {
      background-image: url(https://cdn.artifactuprising.com/assets/images/plp/folded-photo/banner-folded-photo-cards-tablet_2x.jpg?auto=webp&width=1000);
    }

    @media screen and (min-width: 1441px) {
      background-image: url(https://cdn.artifactuprising.com/assets/images/plp/folded-photo/banner-folded-photo-cards-desktop_2x.jpg?auto=webp&width=1000);
    }

    @media only screen and (-webkit-min-device-pixel-ratio: 1.3) and (min-width: 1029px),
      only screen and (-o-min-device-pixel-ratio: 13/10) and (min-width: 1029px),
      only screen and (min-resolution: 120dpi) and (min-width: 1029px) {
      background-image: url(https://cdn.artifactuprising.com/assets/images/plp/folded-photo/banner-folded-photo-cards-desktop_2x.jpg?auto=webp&width=1000);
    }
  }

  .wedding-essentials-hero {
    background-image: url(https://assets.artifactuprising.com/assets/images/clp/bundles/wedding-essentials/banner_mob_2x.jpg);
    padding-bottom: 69.44444444%;

    ${mediaQuery.medium`
      background-image: url(https://assets.artifactuprising.com/assets/images/clp/bundles/wedding-essentials/banner_dsk_2x.jpg);
      padding-bottom: 25%;
        `};
  }

  .wedding-essentials-hero {
    background-color: blue;
  }
`;

export const holidayCard2018TitleStyles = css`
  visibility: visible;
  height: initial;
  top: 100px !important;
  margin-left: 0;
  left: 0;

  ${mediaQuery.medium`
    width 390px;
    left: 50%;
    margin-left: -195px;
  `};

  ${mediaQuery.large`
    width 390px;
    left: -4px;
    margin-left: 0;
  `};
`;

export const weddingSuiteStyles = css`
  ${mediaQuery.medium`
    top: 50px;
  `};
`;

export const desktopHiddenStyles = css`
  ${mediaQuery.medium`
    visibility: hidden;
    height: 0;
  `};
`;

export const holidayCardTitleStyles = css`
  color: #ffffff;
  position: absolute;
  justify-content: center;
  top: 50px;
  margin: 0 -15px;
`;

export const CLPH1 = styled(_StyledH1)<StyledH1Props>`
  margin: 0 0 24px;
  font-size: 24px;
  line-height: initial;
  z-index: 1;
  display: flex;
  width: 100%;

  ${mediaQuery.medium`
    font-size: 2.8125rem;
    position: ${props => (props.floating ? 'absolute' : '')};
    top: ${props => (props.floating ? '150px' : '')};
    justify-content: ${props => (props.centered ? 'center' : '')};
    color: ${props => (props.inverted ? '#ffffff' : '')};
    margin: 0;
  `};

  ${props => (props.isHolidayCard ? holidayCardTitleStyles : '')};
  ${props => (props.isSerifSuite ? weddingSuiteStyles : '')};
  ${props => (props.isInvisibleOnDesktop ? desktopHiddenStyles : '')};
  ${props => (props.isHoliday2018Card ? holidayCard2018TitleStyles : '')};
`;

export const CLPH3 = styled(_StyledH3)`
  margin: 0 0 0 0;
  padding: 0 0 30px 5px;
  font-weight: 400;
  font-family: 'Lato', 'helvetica neue', 'helvetica', 'arial', sans-serif;
  font-size: 18px;
  line-height: 18px;
`;
